import AccountSettingsTab, {
  AccountSettingsTabContent,
  AccountSettingsTabHeader,
  AccountSettingsTabHeaderLeft,
  AccountSettingsTabHeaderRight,
  AccountSettingsTableContainer,
  AccountSettingsTabSubtitle,
  AccountSettingsTabTitle,
} from '../../../../layouts/accountSettingsLayout/accountSettingsTab/accountSettingsTab';
import styles from '../businessAssetsPage.module.css';
import React from 'react';
import { Button, Checkbox } from '@bloobirds-it/flamingo-ui';
import { CustomTasksList } from './customTasksList/customTasksList';
import { useCustomTaskCreation } from './hooks/useCustomTaskCreation';
import { useCustomTasks } from '@bloobirds-it/hooks';

const CustomTaskTab = () => {
  const { showDisabled, setShowDisabled, customTasks, mutate } = useCustomTasks();
  const { setCustomTaskCreation } = useCustomTaskCreation();
  return (
    <AccountSettingsTab>
      <AccountSettingsTabHeader>
        <AccountSettingsTabHeaderLeft>
          <AccountSettingsTabTitle icon="kanban" color="lightPurple">
            <div className={styles._business_asset_title}>Task types</div>
          </AccountSettingsTabTitle>
          <AccountSettingsTabSubtitle>
            Create custom task to keep log custom actions into Bloobirds
          </AccountSettingsTabSubtitle>
        </AccountSettingsTabHeaderLeft>
        <AccountSettingsTabHeaderRight>
          <div className={styles.actions}>
            <Checkbox
              onClick={value => setShowDisabled(value)}
              checked={showDisabled}
              color="purple"
              size="small"
            >
              Show disabled task types
            </Checkbox>
            <Button iconLeft="plus" onClick={() => setCustomTaskCreation(true)} color="purple">
              Add custom task
            </Button>
          </div>
        </AccountSettingsTabHeaderRight>
      </AccountSettingsTabHeader>
      <AccountSettingsTabContent>
        <AccountSettingsTableContainer>
          <CustomTasksList customTasks={customTasks} mutate={mutate} />
        </AccountSettingsTableContainer>
      </AccountSettingsTabContent>
    </AccountSettingsTab>
  );
};

export default CustomTaskTab;
